export default __webpack_public_path__ + "static/fasi-della-metodologia-devops-orangeloop-ae1a3e71043392228bff9adfe6aec6e3.jpg";